<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>

                <rkm-col cols="6">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="model.periodo"
                        :start-validations="validations.periodo.start"
                        :end-validations="validations.periodo.end"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="agendamentoExame"
                        label="Exame / Grupo"
                        show-default-option
                        text-field="nome"
                        v-model="model.exameId"
                        value-field="id"
                        default-option-text="Todos"
                        @change="handleExame()"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="unidadeSolicitante"
                        label="Unidade solicitante"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="unidadeId"
                        default-option-text="Todas"
                        @change="handleUnidadeSolicitante()"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nome"
                        v-model="model.infraestruturaId"
                        valueField="id"
                        show-default-option
                        default-option-text="Todos"
                        @change="handleUnidadeSolicitante()"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row class="flex-nowrap">

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="unidadeColeta"
                        label="Local de coleta"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.coletaUnidadeId"
                        value-field="unidadeId"
                        default-option-text="Todos"
                        @change="setListagem()"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="coletaInfraestruturas"
                        textField="nome"
                        v-model="model.coletaInfraestruturaId"
                        valueField="id"
                        default-option-text="Todos"
                        show-default-option
                        @change="setListagem()"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.Form.validate(search)"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-row class="mt-3" v-if="itemsNotSave && itemsNotSave.length > 0">
            <rkm-col>

                <rkm-button
                    @click="selecionarTodos()"
                    color="primary"
                    class="mb-2"
                >
                    <template v-if="selecionados == false">
                        Selecionar todos
                    </template>

                    <template v-else>
                        Desmarcar selecionado(s)
                    </template>
                </rkm-button>

                <rkm-button
                    v-if="selecionados == true"
                    @click="handleListPrint()"
                    color="info"
                    class="mb-2"
                >
                    Imprimir listagem selecionada
                </rkm-button>

                <rkm-button
                    v-if="selecionados == true"
                    @click="handleEtiquetaPrint()"
                    class="mb-2"
                >
                    Imprimir etiqueta(s) selecionada(s)
                </rkm-button>
            </rkm-col>
        </rkm-row>

        <rkm-table
            v-if="itemsNotSave"
            :items="itemsNotSave || items"
            :fields="fields"
            hide-filters
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            @sort-changed="onSortChanged"
        >

            <template v-slot:cell(checkbox)="{ item }">
                <rkm-form-checkbox
                    v-model="item.selecionado"
                    @change="handleBlur"
                />
            </template>

            <template v-slot:cell(pacienteNome)="{ item }">

                <rkm-button
                    color="secondary"
                    class="mr-2"
                    small
                    v-rkm-popover.hover.right="{
                        title:'Dados cadastrais',
                        html:true,
                        content: handleContent(item)
                        }"
                >
                    <rkm-icon icon="user" />
                </rkm-button>

                {{ item.pacienteNome }}

                <template v-if="item.pacienteNomeSocial">
                    <template v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{ item.pacienteNomeSocial }})</strong>
                    </template>

                    <template v-else>
                        ({{ item.pacienteNomeSocial }})
                    </template>
                </template>
            </template>

            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                    small
                    title="Imprimir etiqueta"
                    @click="handlePrint(item)"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    color="primary"
                    small
                    title="Visualizar"
                    @click="$refs.Modal.open(item)"
                >
                    <rkm-icon icon="search" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase, printExameLaboratorial } from '@/mixins'

// Components.
import Modal from './Modal'

// Moment.
import moment from 'moment'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    components: { Modal },
    computed: {
        fields() {
            const fields = [
                {
                    key: 'checkbox',
                    label: '#',
                    class: 'col-min text-center',
                },
                {
                    key: "data",
                    label: "Data",
                    sortable: true
                },
                {
                    key: "pacienteNome",
                    label: "Nome",
                    sortable: true
                },
                {
                    key: "pacienteIdade",
                    label: "Idade",
                    sortable: true
                },
                {
                    key: "pacienteProntuario",
                    label: "Prontuário",
                    sortable: true
                },
                {
                    key: "agendamentoNumero",
                    label: "Agendamento",
                    sortable: true
                },
                {
                    key: "medicoNome",
                    label: "Médico solicitante",
                    sortable: true
                },
                {
                    key: "coletaUnidadeNome",
                    label: "Unidade coleta",
                    sortable: true
                },
                {
                    key: "coletaInfraestruturaNome",
                    label: "Local de atendimento",
                    sortable: true
                },
                {
                    key: "exameGrupoNome",
                    label: "Exame / Grupo",
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                }
            ]

            return fields
        },
        autocompletesRequestParams() {

            return {
                exame: {
                    queryString: {
                        tipo_id: this.tipoExameId,
                        exame_grupo: true,
                    }
                }
            }
        },
        fieldsAutoComplete() {

            return {
                autocompletes: {
                    exame: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true }
                    ],
                }
            }
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                coletaUnidade: { required: true },
                coletaInfraestrutura: { required: true },
            }
        },
        infraestruturas() {

            if (this.model.unidadeId && this.unidadeSolicitante.length > 0) {

                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).infraestruturas

                return infraestruturaPrincipal
            }

            return []
        },
        coletaInfraestruturas() {

            if (this.model.coletaUnidadeId) {

                let infraestruturaPrincipal = this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId).infraestruturas

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.repositories = {
            coleta: this.getConectaSusRepository('exameLaboratorial.coletaAgendada'),
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                exame: null,
                exameId: null,
                exameNome: null,
                unidadeId: null,
                infraestruturaId: null,
                coletaUnidadeId: null,
                coletaInfraestruturaId: null,
                status: null,
                exames: null,
                grupos: null,
                pertenceGrupo: null,
                filterGrupo: null,
                unidadeNome: null,
                infraestruturaNome: null,
                coletaUnidadeNome: null,
                coletaInfraestruturaNome: null,
                periodo: {
                    start: null,
                    end: null,
                },
            },
            selecionados: false,
            itemsNotSave: null,
            unidadeSolicitante: [],
            unidadeColeta: [],
            agendamentoExame: [],
            items: [],
            enums: {
                statusAgendamento,
                preferenciaNome
            },
            sortBy: 'data',
            sortDesc: false,
        }
    },
    mixins: [repository, error, object, formats, data, printExameLaboratorial, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo = this.data.form.periodo
        },
        onSortChanged(context) {

            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        search() {

            this.setLoading()

            this.selecionados = false

            this.repositories.coleta.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.agendamentos
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            if (this.model.exameId) {

                params.pertenceGrupo = this.agendamentoExame.find(u => u.id == this.model.exameId).pertenceGrupo
                params.filterGrupo = this.agendamentoExame.find(u => u.id == this.model.exameId).filterGrupo
                params.exameNome = this.agendamentoExame.find(u => u.id == this.model.exameId).nome
            }

            if (this.model.unidadeId) {

               this.model.unidadeNome = this.data.form.unidades.find(u => u.id == this.model.unidadeId).nomeFantasia
            }
            if (this.model.infraestruturaId && this.infraestruturas.length > 0) {

               this.model.infraestruturaNome = this.infraestruturas.find(u => u.id == this.model.infraestruturaId).nome
            }

            if (this.model.coletaUnidadeId) {

               this.model.coletaUnidadeNome = this.data.form.unidades.find(u => u.id == this.model.coletaUnidadeId).nomeFantasia
            }
            if (this.model.coletaInfraestruturaId) {

               this.model.coletaInfraestruturaNome = this.coletaInfraestruturas.find(u => u.id == this.model.coletaInfraestruturaId).nome
            }

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            params.sortBy = this.sortBy
            params.sortDesc = this.sortDesc

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.model.exame = null
            this.model.exameId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.itemsNotSave = null
            this.selecionados = false

            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        handleInfraestrutura(infraestruturaPrincipal) {

            if (infraestruturaPrincipal.find(u => u.principal === true)) {

                this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
            } else {

                this.model.infraestruturaId = null
            }
        },
        handleColetaInfraestrutura(infraestruturaColetaPrincipal) {

            if (infraestruturaColetaPrincipal.find(u => u.principal === true)) {

                this.model.coletaInfraestruturaId = infraestruturaColetaPrincipal.find(u => u.principal === true).id
            }
        },
        setInfraestrutura() {
            if(!this.model.unidadeId) {
                this.model.infraestruturaId = null;
                return;
            }
            this.model.infraestruturaId = this.data.initials.model.atendimentoUnidadeId ? this.data.initials.model.atendimentoUnidadeId : null
        },
        setColetaInfraestrutura() {

            this.model.coletaInfraestruturaId = null
        },
        handleListPrint() {

            this.setLoading()

            this.handleSelecionados()

            this.repositories.impressao.coletaAgendada(this.getSearchParams())
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        },
        handleEtiquetaPrint() {

            let etiqueta = this.itemsNotSave.filter(etiqueta => etiqueta.selecionado)

            this.print().etiquetaColeta(etiqueta, this.data.form.sistema, this.data.form.unidade)

        },
        handlePrint(item) {

            this.print().etiquetaColetaIndividual(item, null, this.data.form.sistema, this.data.form.unidade)
        },
        loadFields() {

            this.setLoading()

            this.setListagem()

            this.repositories.coleta.loadFields(this.getSearchParams())
                .then(({ data }) => {
                    
                    this.loadExame(data.model.agendamentos)
                    this.loadUnidadeSolicitante(data.model.unidades)
                    this.loadUnidadeColeta(data.model.coletas)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadUnidadeSolicitante(agendamento) {

            const unidades = []

           agendamento.map(infraestrutura => {

                let principal = this.data.form.unidades.find(u => u.id ===
                    infraestrutura.unidadeId).infraestruturas.find(u => u.id
                        === infraestrutura.infraestruturaId).principal

                const unidadeInserida = unidades.find(u => u.unidadeId
                    === infraestrutura.unidadeId)

                if (unidadeInserida) {

                    let verifyUnidade = unidadeInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.infraestruturaId)

                    if (!verifyUnidade) {

                        unidadeInserida.infraestruturas.push({

                            id: infraestrutura.infraestruturaId,
                            nome: infraestrutura.infraestruturaNome,
                            principal: principal,
                        })
                    }

                } else {

                    unidades.push({

                        unidadeId: infraestrutura.unidadeId,
                        nomeFantasia: infraestrutura.unidadeNome,
                        infraestruturas: [
                            {
                                id: infraestrutura.infraestruturaId,
                                nome: infraestrutura.infraestruturaNome,
                                principal: principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeSolicitante = unidades
            const unidadesExistentes = this.unidadeSolicitante.map(q => q.unidadeId);

            if(this.data.initials.model.unidadeId && (unidadesExistentes.includes(this.data.initials.model.unidadeId))) {
                this.model.unidadeId = this.data.initials.model.unidadeId;
            }
        },
        loadUnidadeColeta(agendamento) {

            const coleta = []

           agendamento.map(infraestrutura => {

                let principal = this.data.form.unidades.find(u => u.id ===
                    infraestrutura.coletaUnidadeId).infraestruturas.find(u => u.id
                        === infraestrutura.coletaInfraestruturaId).principal

                const coletaInserida = coleta.find(u => u.unidadeId
                    === infraestrutura.coletaUnidadeId)

                if (coletaInserida) {

                    let verifyUnidade = coletaInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.coletaInfraestruturaId)

                    if (!verifyUnidade) {

                        coletaInserida.infraestruturas.push({

                            id: infraestrutura.coletaInfraestruturaId,
                            nome: infraestrutura.coletaUnidadeNome,
                            principal: principal,
                        })
                    }

                } else {

                    coleta.push({

                        unidadeId: infraestrutura.coletaUnidadeId,
                        nomeFantasia: infraestrutura.coletaUnidadeNome,
                        infraestruturas: [
                            {
                                id: infraestrutura.coletaInfraestruturaId,
                                nome: infraestrutura.coletaInfraestruturaNome,
                                principal: principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeColeta = coleta
            const coletasExistentes = this.unidadeColeta.map(q => q.unidadeId);

            if(this.data.initials.model.coletaId && (coletasExistentes.includes(this.data.initials.model.coletaId))) {
                this.model.coletaUnidadeId = this.data.initials.model.coletaId;
            }
        },
        loadExame(agendamento) {

            const exameCadastrado = []

           agendamento.map(exame => {

                const exameInserido = exameCadastrado.find(u => u.id
                    === exame.exameGrupoId && u.pertenceGrupo === exame.pertenceGrupo)

                if (!exameInserido) {

                    exameCadastrado.push({

                        id: exame.exameGrupoId,
                        nome: exame.exameGrupoNome,
                        pertenceGrupo: exame.pertenceGrupo,
                        filterGrupo: exame.filterGrupo,
                    })
                }
            })

            if (exameCadastrado) {

                exameCadastrado.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
            }

            this.agendamentoExame = exameCadastrado
        },
        setListagem() {

            this.itemsNotSave = null
        },
        selecionarTodos(){

            if(this.selecionados == true){

                this.selecionados = false
            } else {

                this.selecionados = true
            }

            this.itemsNotSave.forEach(element => {

                if(this.selecionados == true){

                    element.selecionado = true

                } else {

                    element.selecionado = false
                }
            })
        },
        handleSelecionados() {

            if (this.itemsNotSave) {

                const exameSelecionado = []
                const grupoSelecionado = []

                this.model.exames = null
                this.model.grupos = null

                this.itemsNotSave.filter(item => item.selecionado).map(exame => {

                    if (!exameSelecionado.find(u => u.id === exame.exameGrupoId
                        &&  u.agendamentoId === exame.agendamentoId)) {

                            exameSelecionado.push({
                                id: exame.exameGrupoId,
                                agendamentoId: exame.agendamentoId,
                            })
                    }
                })

                this.itemsNotSave.filter(item => item.selecionado && item.pertenceGrupo).map(exame => {

                    if (!grupoSelecionado.find(u => u.id === exame.exameGrupoId
                        && u.agendamentoId === exame.agendamentoId)) {

                            grupoSelecionado.push({

                                id: exame.exameGrupoId,
                                agendamentoId: exame.agendamentoId
                            })
                    }
                })

                this.model.exames = exameSelecionado
                this.model.grupos = grupoSelecionado
            }
        },
        handleBlur(){

            let selecionado = false

            this.itemsNotSave.map(element => {

                if (element.selecionado == true) {

                    selecionado = true
                }
            })

            if (selecionado) {

                this.selecionados = true
            } else {

                this.selecionados = false
            }
        },
        handleContent(item) {

            let rg = item.rg ?? 'Não informado'
            let endereco = item.endereco ?? 'Não informado'
            let telefone = item.pacienteTelefone ? this.formatPhoneOrCellPhone(item.pacienteTelefone) : 'Não informado'

            return '<b>RG</b>:  ' + rg + '<br />'
                + '<b>Endereço</b>: ' + endereco + '<br />'
                + '<b>Telefone</b>: ' + telefone + '<br />'
        },
        handlePeriodo() {

            this.model.exameId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null

            this.loadFields()
        },
        handleExame() {

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null

            this.loadFields()
        },
        handleUnidadeSolicitante() {

            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null

            this.loadFields()
        },
    },
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        'model.periodo.start'() {

            if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()
            }
        },
        'model.periodo.end'() {

           if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()

            }
        },
        'model.unidadeId'() {

            this.setInfraestrutura()

            if (this.model.unidadeId && this.unidadeSolicitante.length > 0) {
                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).infraestruturas
                this.handleInfraestrutura(infraestruturaPrincipal)
            }
        },
        'model.coletaUnidadeId'() {

            this.setColetaInfraestrutura()

            if (this.model.coletaUnidadeId) {

                let infraestruturaPrincipal = this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId).infraestruturas

                this.handleColetaInfraestrutura(infraestruturaPrincipal)
            }
        },
    }
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-width {
    width: 100%;
}

.popover{
    max-width: 70%;
    width: auto;
}

</style>